import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DateValidator } from '../../Validators/date-validator';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { AutocompleteInputOptions } from '../select-autocomplete/select-autocomplete.component';

@Component({
  selector: "ben-date-of-birth",
  templateUrl: "./date-of-birth.component.html",
  styleUrls: ["./date-of-birth.component.scss"]
})

export class DateOfBirthComponent implements OnInit{
  minYear: number = 1900;
  maxYear: number = new Date().getFullYear();
  days: string[] = [];
  filteredDays: Observable<AutocompleteInputOptions[]>;
  filteredMonths: Observable<AutocompleteInputOptions[]>;
  filteredYears: Observable<AutocompleteInputOptions[]>;
  dateForm: FormGroup;
  dayControl: FormControl;
  monthControl: FormControl;
  yearControl: FormControl;
  showErrorMessage = false;
  years: string[] = [];
  months = ['January','February','March','April','May','June','July','August', 'September','October','November','December'];
  constructor(private formBuilder: FormBuilder) {
  }
  ngOnInit(): void {
    this.dateFormCreator();
   }

  filterDays(value: string): AutocompleteInputOptions[] {
    if (value.length > 0) {
      return this.days.filter(day => day.startsWith(value)).map(m => { return { value: m, displayOption: m } });
    } else {
      return this.days.map(m => { return { value: m, displayOption: m } });
    }
  }

  filterMonths(value: string): AutocompleteInputOptions[] {
    const filterValue = value.toLowerCase();
    return this.months.filter(month => month.toLowerCase().startsWith(filterValue)).map(m => { return { value: m, displayOption: m } });
  }

  filterYears(value: string): AutocompleteInputOptions[] {
    return this.years.filter(year => year.toString().startsWith(value)).map(m => { return { value: m, displayOption: m } });
  }

  getDateOfBirth(): Date  {
    this.dateForm.markAllAsTouched();
    this.dateForm.updateValueAndValidity();
    
    const day = this.dateForm.get('day')?.value;
    const month = this.dateForm.get('month')?.value;
    const year = this.dateForm.get('year')?.value;

    var monthNumeric = this.months.findIndex(m => m == month);;

    return new Date(Date.UTC(year, monthNumeric, day));
  }

  openOnClick(trigger: MatAutocompleteTrigger) {
    if (!trigger.panelOpen)
      trigger.openPanel();
  }

  closeOnBlur($event: any, trigger: MatAutocompleteTrigger) {
    if ($event.relatedTarget == null) {
      $event.target.blur();
      trigger.closePanel();
    }
  }

  private dateFormCreator() {
    this.dayControl = new FormControl('', [Validators.minLength(1)]);
    this.monthControl = new FormControl('', [Validators.minLength(1)]);
    this.yearControl = new FormControl('', [Validators.min(1900), Validators.minLength(4)]);

    this.dateForm = this.formBuilder.group({
      day: this.dayControl,
      month: this.monthControl,
      year: this.yearControl
    }, { validator: [DateValidator.dateOfBirthRequired, DateValidator.validateDateOfBirth] });

    this.days = this.getValuesBetween(1, 31);
    this.daysToNumber();

    this.monthsToString();

    this.years = this.getValuesBetween(this.minYear, this.maxYear).reverse();
    this.yearsToNumbers();

    
  }

  private daysToNumber() {
    this.filteredDays = (this.dayControl.valueChanges as Observable<string>).pipe(
      startWith(''),
      map(value => {
        return this.filterDays(this.dayControl.value);
      })
    );
  }
  private monthsToString() {
    this.filteredMonths = (this.monthControl.valueChanges as Observable<string>).pipe(
      startWith(''),
      map(value => this.filterMonths(this.monthControl.value))
    );
  }
  private yearsToNumbers() {
    this.filteredYears = (this.yearControl.valueChanges as Observable<string>).pipe(
      startWith(''),
      map(value => {
        return this.filterYears(this.yearControl.value)
      })
    );
  }

  private getValuesBetween(min: any, max: number): string[] {
    var valueList = [];

    for (var i = min; i <= max; i++) {
      valueList.push(i.toString());
    }
    return valueList;
  }
}
